import MemoryFoamVsLatexFoam from "../../components/pages/blog/memory-form-vs-latex-foam";

export default MemoryFoamVsLatexFoam;
